var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 175V25H175V175H25Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.075 137.279C125.958 141.963 129.092 146.45 135.729 146.45C141.304 146.45 144.229 143.679 144.229 139.846C144.229 135.258 141.204 133.629 135.071 130.958L131.708 129.525C122.004 125.408 115.55 120.25 115.55 109.354C115.55 99.3126 123.237 91.6709 135.25 91.6709C143.804 91.6709 149.95 94.6334 154.383 102.392L143.908 109.088C141.604 104.971 139.112 103.35 135.25 103.35C131.308 103.35 128.812 105.838 128.812 109.088C128.812 113.104 131.312 114.729 137.083 117.217L140.446 118.65C151.883 123.521 158.333 128.496 158.333 139.679C158.333 151.729 148.817 158.333 136.042 158.333C123.546 158.333 116.45 152.063 112.5 144.3L123.075 137.279ZM74.8 137.621C76.9083 141.396 80.1125 144.3 84.7208 144.3C89.1291 144.3 91.6666 142.558 91.6666 135.788V91.6667H105.554V137.921C105.554 151.95 97.4166 158.333 85.5333 158.333C74.7958 158.333 67.0458 151.058 63.8875 144.3L74.8 137.621Z",
    fill: "#000001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/JS.4fa71819d2dac76a37ce159a29ceef06.svg";
export { ForwardRef as ReactComponent };